import React, { useEffect, useState } from "react";
import "./style.scss";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { PATH_LIST } from "shared/lib/react-router";
import { useTranslation } from "react-i18next";
import { ChangeLanguage } from "widgets/change-language";
import AuthChat from "../../../assets/AuthChat.svg";
import AuthBack from "../../../assets/AuthBack.svg";
import { AuthContactsModal } from "pages/onboarding/components/contacts-modal";
import { Capacitor } from "@capacitor/core";

export const AuthLayout = () => {
  const { t } = useTranslation("onboarding-auth");
  const navigate = useNavigate();
  const location = useLocation();
  const [chatOpened, setChatOpened] = useState(false);

  const handleNavigate = () => {
    location.pathname !== PATH_LIST.login
      ? navigate(PATH_LIST.welcome)
      : navigate(-1);
  };

  return (
    <div className="auth-layout">
      <nav
        className={
          location.pathname !== PATH_LIST.welcome
            ? "navbar"
            : "navbar welcome-navbar"
        }
        style={{
          paddingTop: Capacitor.isNativePlatform() ? "16px" : "36px",
        }}
      >
        {location.pathname !== PATH_LIST.welcome && (
          <button
            onClick={handleNavigate}
            style={{
              justifyContent: "flex-start",
            }}
          >
            <img className="go-back" src={AuthBack} alt="back" />
          </button>
        )}

        <div className="navbar-right">
          <ChangeLanguage
            // dark={location.pathname !== PATH_LIST.welcome ? true : false}
            dark={true}
          />
          {location.pathname !== PATH_LIST.welcome && (
            <button
              onClick={() => setChatOpened(true)}
              style={{
                justifyContent: "flex-end",
              }}
            >
              <img className="open-chat" src={AuthChat} alt="chat" />
            </button>
          )}
        </div>
      </nav>

      <Outlet />

      {location.pathname !== PATH_LIST.welcome && (
        <div
          className="footer"
          style={{
            paddingBottom: Capacitor.isNativePlatform() ? "16px" : "28px",
          }}
        >
          <p>
            {t("dontHaveAcc")}{" "}
            <a href={PATH_LIST.chooseAccType}>{t("signUp")}</a>
          </p>
        </div>
      )}

      {chatOpened && <AuthContactsModal onClose={() => setChatOpened(false)} />}
    </div>
  );
};
